<template>
  <div class="loginPage">
    <div class="login" >
      <img class="login-close" src="@/assets/imgs/login-close.png" alt="" @click="closeHandle">
      <div class="login_header">
        <img src="@//assets/imgs/ai.png" alt="">
        <div class="login_header_right">
          <p>欢迎来到 AI教师助手</p>
          <p>赶快登录吧！</p>
        </div>
      </div>
      <div class="login-input">
        <div class="login-account"  :class="userNameError ? 'error' :''">
          <input type="text" v-model.trim="userName" placeholder="用户名/手机号" :class="{ 'error-input': userNameError }" @input="userNameError = ''">
          <!-- <img src="@/assets/imgs/login-clear.png" @click="userName=''" alt=""> -->
          <div class="error-tip" v-if="userNameError">{{ userNameError }}</div>
        </div>
        <div class="login-account" :class="passwordError ? 'error' :''">
          <input type="password" ref="passwordRef" v-model.trim="password" placeholder="登录密码" :class="{ 'error-input': passwordError }" @input="passwordError = ''">
          <img v-if="isP" src="@/assets/imgs/password-see.png" alt="" @click="clickPassword">
          <img v-else src="@/assets/imgs/password-hidden.png" alt="" @click="clickPassword">
          <div class="error-tip" v-if="passwordError">{{ passwordError }}</div>
        </div>
      </div>
      <Check style="width: 330px;" @success="checkHandle"></Check>
      <div class="login-btn" @click="loginHandle">登录</div>
      <div class="login-other">
        <span @click="goRegister">立即注册</span>
        <span @click="goForgotPassword">忘记密码</span>
      </div>
    </div>
  </div>
</template>


<script setup>
import { ref } from 'vue';
import Check from './components/check.vue';
import { userLogin,  sendAIPhone, registerAIAccount, resetAIPassword } from '@/api/index';
import AES from '@/utils/AES';
import location from "@/utils/location";
const domain = location.domain();
import useHomeStore from '@/store/home'
import { ElMessage } from 'element-plus';
import router from '@/router';
const homeStore = useHomeStore()


// 用户名
const userName = ref('');
// 密码
const password = ref('');
// 验证
const checkFlag = ref(false);
const checkHandle = (val) => {
  checkFlag.value = val;
};

// 登录
const userNameError = ref('');
const passwordError = ref('');
const checkError = ref('');

const loginHandle = async () => {
  // 清除之前的错误提示
  userNameError.value = '';
  passwordError.value = '';
  checkError.value = '';
  
  let hasError = false;
  
  if (!userName.value) {
    userNameError.value = '请输入账号信息！'
    hasError = true;
  }
  if (!password.value) {
    passwordError.value = '请输入密码！'
    hasError = true;
  }
  if (hasError) {
    return;
  }

  if (!checkFlag.value.flag) {
    checkError.value = '请滑动滑块验证！'
    ElMessage.warning('请滑动滑块验证！')
    return;
  }
  

  const res = await userLogin({
    password: AES.encrypt(password.value),
    username: userName.value,
    verifyImageResult: {
      captchaSerialNumber: checkFlag.value.imgSwipe.captchaSerialNumber,
      moveEnd_X: checkFlag.value.width,
      wbili: 1
    }
  })

  if (res.success) {
    if (res.data.infoStatus == 1) {
      const currentPath = router.currentRoute.value.path;
      const currentQuery = { ...router.currentRoute.value.query };
      currentQuery.info = res.data.info;
      router.replace({ path: currentPath, query: currentQuery });
      // 延迟刷新页面，确保路由参数已设置完成
      setTimeout(() => {
        router.go(0);
      }, 100);
    } else {
      ElMessage.error(res.data.info);
    };
  } else {
    ElMessage.error(res.msg);
  };
};

//去注册
const goRegister = () => {
  homeStore.changeLogin();
  homeStore.changeReg();
}

//点击忘记密码
const goForgotPassword = () => {
  homeStore.changeLogin();
  homeStore.changeForget();
}

// 关闭
const closeHandle = () => {
  homeStore.changeLogin();
};

//点击显示密码
const passwordRef = ref()
const isP = ref(false);
const clickPassword = () => {
  passwordRef.value.type = passwordRef.value.type == 'text' ? 'password' : 'text';
  isP.value = passwordRef.value.type == 'text' ? true : false;
}

</script>

<style scoped lang='scss'>
//移除 Edge 浏览器对 input[type="password"]默认显示的密码切换图标（眼睛图标）
input[type="password"]::-ms-reveal {
  display: none !important; /* 强制覆盖默认样式 */
  width: 0 !important;      /* 可选：消除图标占位空间 */
  height: 0 !important;     /* 可选：同上 */
}
.mt24{
  margin-top: 24px;
}
.loginPage {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  .login {
    background: #FFFFFF;
    border-radius: 16px;
    position: fixed;
    top: calc(50vh - 340px);
    left: calc(50vw - 205px);
    padding: 48px 40px;
    box-sizing: border-box;
    .login-close{
      position: absolute;
      right: 24px;
      top: 24px;
      cursor: pointer;
    }
    .login_header {
      display: flex;
      margin-bottom: 48px;
      img {
        width: 64px;
        height: 64px;
        margin-right: 24px;
      }
      .login_header_right {
        p:nth-child(1) {
          font-family: MicrosoftYaHei-Bold;
          font-size: 24px;
          color: #161616;
          letter-spacing: 0;
          font-weight: 700;
        }
        p:nth-child(2) {
          font-family: MicrosoftYaHei;
          font-size: 16px;
          color: #666666;
          letter-spacing: 0;
          font-weight: 400;
          margin-top: 6px;
        }
      }
    }
    .tips {
      margin-left: 16px;
      font-family: MicrosoftYaHei;
      font-size: 14px;
      color: #FF0000;
      letter-spacing: 0;
      font-weight: 400;
      height: 20px;
      margin-top: 24px;
      opacity: 0;
      &.showTips {
        opacity: 1;
      }
    }
    .login-input {
      margin-bottom: 24px;
      input {
        width: 330px;
        height: 48px;
        box-sizing: border-box;
        background: #ffffff;
        border: 1px solid rgba(236, 236, 236, 1);
        border-radius: 4px;
        padding-left: 16px;
        padding-top: 8px;
        &::placeholder {
          font-family: MicrosoftYaHei;
          font-size: 16px;
          color: #bbbbbb;
          font-weight: 400;
        }
      }
      input:focus-visible {
        border-color: rgba(236, 236, 236, 1);
        box-shadow: none;
        outline: none;
        border: 1px solid rgba(27,132,255,1);
      }
      input.error-input {
        border: 1px solid rgba(255,23,23,1);
      }
      input.error-input:focus-visible {
        border: 1px solid rgba(255,23,23,1);
      }
      /* 1. 针对 Firefox 浏览器 */
      input[type="number"] {
        -moz-appearance: textfield; /* 移除 Firefox 内置的数字箭头 */
        appearance: textfield; /* 标准属性，兜底 */
      }

      /* 2. 针对 Webkit/Chromium 浏览器（Chrome、Safari、新版 Edge） */
      input[type="number"]::-webkit-inner-spin-button,
      input[type="number"]::-webkit-outer-spin-button {
        -webkit-appearance: none; /* 移除 Webkit 内置的 spin 按钮 */
        margin: 0; /* 清除默认边距，避免输入框内部布局异常 */
      }

      /* 3. 针对旧版 IE/Edge（IE10+）【可选，现代浏览器可忽略】 */
      input[type="number"]::-ms-inner-spin-button {
        display: none; /* 移除 IE 内置的 spin 按钮 */
      }

      /* 可选：保持输入框样式一致性（如禁用焦点轮廓、自定义样式） */
      input[type="number"] {
        padding: 8px 12px;
        border: 1px solid #ddd;
        border-radius: 4px;
        outline: none;
      }
      /* IE11兼容 */
      @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
        input:focus {
          border-color: rgba(236, 236, 236, 1);
        }
      }
      .login-account {
        position: relative;
         margin-bottom: 24px;
        &.error{
          margin-bottom: 8px;
        }
        &.flex{
          display: flex;
          align-items: center;
          justify-content: space-between;
        }

        img {
          position: absolute;
          right: 14px;
          top: 13px;
          width: 24px;
          cursor: pointer;
        }
        .send-btn{
          width: 117px;
          height: 48px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #FFFFFF;
          border: 1px solid rgba(236,236,236,1);
          border-radius: 6px;
          cursor: pointer;
          &.sended{
            font-family: PingFangSC-Regular;
            font-size: 16px;
            color: #95AAB9;
            font-weight: 400;
          }
        }
        .error-tip {
          margin-top: 2px;
          font-family: PingFangSC-Regular;
          font-size: 12px;
          color: #FF0000;
          font-weight: 400;
        }
      }
    }
    .login-btn {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 24px;
      margin-bottom: 24px;
      width: 330px;
      height: 48px;
      background-image: linear-gradient(90deg, #3BE1F9 0%, #3363FF 50%, #9377FF 100%);
      border-radius: 4px;
      font-family: MicrosoftYaHei-Bold;
      font-size: 20px;
      color: #ffffff;
      font-weight: 700;
      cursor: pointer;
    }
    .login-other {
      display: flex;
      justify-content: space-between;
      span {
        cursor: pointer;
        color: #1B84FF;
        &:hover {
          color: #1B84FF;
        }
      }
    }
  }
}
.back-login{
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: PingFangSC-Regular;
  font-size: 18px;
  color: #1B84FF;
  font-weight: 400;
  cursor: pointer;
}


</style>